export const SESSION_TIMEOUT = 30 * 60 * 1000;